import { GC_GET_LOCATION_LIST, GC_GET_LOCATION_BY_SLUG } from '@/graphql/location'
import apollo from '@/apolloClient'

export default {
    namespaced: true,
    state: {
        list: [],
        itemsBySlug: {},
    },
    mutations: {
        SET_LOCATION_LIST(state, locations){
            state.list = (locations || [])
        },
        SET_LOCATION_BY_SLUG(state, location) {
            if (!location || !location.slug)
                return

            state.itemsBySlug[location.slug] = location
        },
    },
    actions: {
        async getList({ commit }){
            const response = await apollo.query({query: GC_GET_LOCATION_LIST})

            commit('SET_LOCATION_LIST', response.data.location)
        },
        async getBySlug({ commit }, slug) {
            let response = await apollo.query({
                query: GC_GET_LOCATION_BY_SLUG,
                variables: { slug }
            })

            if (!response.data.location || response.data.location.length <= 0) {
                return
            }

            commit('SET_LOCATION_BY_SLUG', response.data.location[0])
        },
    }
}